export const shareDlg = {
  "title": "Share files",
  "SharedFileLink": {
    "platformNameReader": "Foxit PDF Reader",
    "platformName": "Foxit PDF Editor",
    "title": "Shared file link",
    "content": "Get a link of this file to share with others to allow others to view this PDF file online as visitors or sign in to add comments. This file can be accessed by anyone with this link.",
    "allow": "Allow Comments",
    "canComment": "Can Comment",
    "canView": "Can View",
    "CreateBtnText": "Create a link",
    "copyBtnText": "Copy link",
    "commentingBtn": "Start collaboration",
    "waitTitle": "Please wait while preparing to share...",
    "waitText": "",
    "DueBy": "Due by",
    "Remove": "Remove"
  },
  "ShareWithEmail": {
    "title": "Share with Email",
    "fileName": "File name",
    "content": "Set permission with some people so that they can view your files or add comments.",
    "allow": "Allow Comments",
    "searchPlaceholder": "Enter email address...",
    "textareaPlaceholder": "Please add comments to this document (Default message content)",
    "addDeadline": "Add deadline",
    "waitTitle": "Please wait for it to be sent..",
    "waitText": "Sending...",
    "sendBtnText": "Send",
    "emptyEmail": "Email address is required",
    "DueBy": "Due by",
    "addInfo": "Add information (optional)"
  },
  "ShareSuccess": {
    "title": "\"{fileName}\" was successfully sent",
    "content": "The file has been shared, you can start Review",
    "commentingText": "You can click the below to start collaboration",
    "cancelBtnText": "Cancel",
    "commentBtnText": "Start collaboration",
    "openBtnText": "Open shared file"
  },
  "errorMessage": {
    "noflie": "Please select file",
    "moreThanLimitLength": "The message can't be more than {limitLength} characters"
  }
}